class MycrmCheckboxCtrl {
  onTrigger(value) {
    this.value = !value;
    this.onChange({ value: this.value });
  }
}

export default MycrmCheckboxCtrl;
